import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { AppVersionCheckPage } from '@/features/appVersionCheck/pages/AppVersionCheckPage';
import { appVersionCheckSearchSchema } from '@/features/appVersionCheck/types/appVersionCheck.types';

export const Route = createFileRoute('/_auth/reports/app-version-check')({
  validateSearch: appVersionCheckSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="App Version Check">
      <Suspense fallback={<PageLoader />}>
        <AppVersionCheckPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
